import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n"; // <-- Inicializa i18next antes de renderizar la app
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@mui/x-data-grid-pro/themeAugmentation";
import { registerLicense } from "@syncfusion/ej2-base";
import { LicenseInfo } from "@mui/x-license-pro";
import { registerCompasOfflineServiceWorker } from "./compasOfflineSw";

if (typeof window !== "undefined") {
  const resizeObserverMessagePattern =
    /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;

  const isResizeObserverLoopError = (value) => {
    const message =
      typeof value === "string"
        ? value
        : value?.message || value?.reason?.message || "";
    return resizeObserverMessagePattern.test(message);
  };

  window.addEventListener(
    "error",
    (event) => {
      if (!isResizeObserverLoopError(event?.message || event?.error)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true,
  );

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      if (!isResizeObserverLoopError(event?.reason)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true,
  );

  // Dev-only fallback: remove runtime overlay node if it still gets injected.
  setInterval(() => {
    const overlayNodes = document.querySelectorAll(
      '[id*="webpack-dev-server-client-overlay"], iframe[id*="overlay"]',
    );
    overlayNodes.forEach((node) => {
      if (node && node.parentNode) node.parentNode.removeChild(node);
    });
  }, 1000);
}

registerLicense(process.env.REACT_APP_SYNCFUSION_KEY);
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_KEY);

/* MUI PRO */
/* LicenseInfo.setLicenseKey(
  "d009f170776868af690171fbe41dc0fdTz0xMTQ1MDAsRT0xNzgxMzA4Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI="
); */

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

registerCompasOfflineServiceWorker();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
